import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api, fmtDate } from "../lib/api";
import { Button } from "../components/ui/button";
import { Bell } from "lucide-react";
import { localeOf } from "../i18n";

export default function Notifications() {
  const { t, i18n } = useTranslation();
  const [items, setItems] = useState([]);
  const locale = localeOf(i18n.language);

  const load = () => api.get("/notifications").then(({ data }) => {
    setItems(data);
    window.dispatchEvent(new Event("vy:notifications-changed"));
  });
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-4" data-testid="notifications-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-display text-2xl font-extrabold">{t("notif.title")}</h1>
        <Button data-testid="notifications-mark-all-btn" variant="outline"
          className="h-10 shrink-0 whitespace-nowrap rounded-full px-4 text-xs font-bold"
          onClick={async () => { await api.post("/notifications/read-all"); load(); }}>
          {t("notif.markAll")}
        </Button>
      </div>
      {items.length === 0 && (
        <p data-testid="notifications-empty" className="vy-card p-6 text-center text-sm text-muted-foreground">
          {t("notif.empty")}
        </p>
      )}
      <ul className="space-y-3">
        {items.map((n) => (
          <li key={n.id} data-testid={`notification-${n.id}`}
            className={`vy-card flex gap-3 p-4 ${n.read ? "opacity-60" : ""}`}>
            <Bell className={`mt-0.5 h-5 w-5 shrink-0 ${n.critical ? "text-accent" : "text-primary"}`} />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-bold">{n.title}</p>
              <p className="text-sm text-muted-foreground">{n.body}</p>
              <p className="mt-1 text-xs text-muted-foreground">{fmtDate(n.created_at, locale)}</p>
            </div>
            {!n.read && (
              <button data-testid={`notification-read-${n.id}`}
                onClick={async () => { await api.post(`/notifications/${n.id}/read`); load(); }}
                className="text-xs font-bold text-primary">✓</button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
